import { render, staticRenderFns } from "./CrudHeader.vue?vue&type=template&id=4e944b52&scoped=true&"
import script from "./CrudHeader.vue?vue&type=script&lang=js&"
export * from "./CrudHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e944b52",
  null
  
)

export default component.exports